module.exports = __webpack_public_path__ + "img/运动活动-3@2x.b11a132d.png";